import { Pagination, paginationToParams } from '../Pagination';

export interface BoynerOrderFilter {
  pagination: Pagination;
}

export const getDefaultBoynerOrderFilter = (): BoynerOrderFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const boynerOrderFilterToQueryParams = (filter: BoynerOrderFilter) => ({
  ...paginationToParams(filter.pagination),
});
